/**
 * CustomerSpeed.API
 * API that manages account-specific speed limit overrides.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * DTO representing a geographic coordinate point in HERE maps compressed format. Used to represent geometry data for road segments.              Decoding: split the comma-separated string into integers. The first integer is the absolute coordinate (divide by 1e5 to get degrees). Each subsequent integer is a delta from the previous value. Apply the same logic to both Lat and Lng to get paired (lat, lng) points.              Direction: when direction is \"-\", the decoded coordinates are in reverse topological order. Clients must reverse the points of \"-\" links before stitching to produce a consistent A→B polyline.              Distance: once decoded, use the Haversine formula between consecutive points to compute segment length.
 */
export interface GeometryDto {
  /**
   * The latitude coordinate in HERE maps compressed format. The first value is the absolute coordinate (scaled by 1e-5), subsequent values are deltas from the previous point. Example: \"4174016,24,77\" decodes to latitudes 41.74016, 41.74040, 41.74117.
   */
  lat: string | null;
  /**
   * The longitude coordinate in HERE maps compressed format. Same encoding as Lat — first value is absolute (scaled by 1e-5), rest are deltas. Example: \"-12416259,-49,-157\" decodes to longitudes -124.16259, -124.16308, -124.16465.
   */
  lng: string | null;
  /**
   * The attribute direction of this geometry link relative to the road topology. \"+\" means coordinates are stored in the forward reference direction (A→B). \"-\" means coordinates are stored in the backward reference direction (B→A). Clients must reverse the decoded points of \"-\" links before stitching into a polyline.
   */
  direction: GeometryDto.DirectionEnum;
}
export namespace GeometryDto {
  export type DirectionEnum = '+' | '-';
  export const DirectionEnum = {
    Plus: '+' as DirectionEnum,
    Minus: '-' as DirectionEnum
  };
}
